import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomerBillingCustomerListComponent } from './customer-billing-customer-list/customer-billing-customer-list.component';
import { OtherInvoicesListItemComponent } from './other-invoices-list-item/other-invoices-list-item.component';
import { UtilitiesModule } from '@fi-app/utilities/utilities.module';
import { ComponentsModule } from '@fi-app/components/components.module';
import { CustomerService } from './customer.service';
import { MonthlyInvoicesListItemComponent } from './monthly-invoices-list-item/monthly-invoices-list-item.component';
import { CustomerBillingCustomerViewComponent } from './customer-billing-customer-view/customer-billing-customer-view.component';
import { CustomerBillingComponentsModule } from '../customer-billing-components/customer-billing-components.module';
import { CustomerBillingCustomerEditComponent } from './customer-billing-customer-edit/customer-billing-customer-edit.component';
import { MatRadioModule } from '@angular/material/radio';
import { BillingComponentsModule } from '@fi-app/billing/billing-components/billing-components.module';
import { FormsModule } from '@angular/forms';
import { CustomerBillingCustomerListStateComponent } from './customer-billing-customer-list/customer-billing-customer-list-state.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FiPageHeaderModule } from '@fi-app/components/fi-page-header/fi-page-header.module';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CustomerBillingCustomerEditCustomerInformationComponent } from './customer-billing-customer-edit/customer-billing-customer-edit-customer-information/customer-billing-customer-edit-customer-information.component';
import { CustomerBillingCustomerEditPaymentInformationComponent } from './customer-billing-customer-edit/customer-billing-customer-edit-payment-information/customer-billing-customer-edit-payment-information.component';
import { CustomerBillingCustomerEditInvoiceInformationComponent } from './customer-billing-customer-edit/customer-billing-customer-edit-invoice-information/customer-billing-customer-edit-invoice-information.component';
import { CustomerBillingCustomerEditCreditCardInformationComponent } from './customer-billing-customer-edit/customer-billing-customer-edit-credit-card-information/customer-billing-customer-edit-credit-card-information.component';
import { CustomerBillingCustomerEditUsageInformationComponent } from './customer-billing-customer-edit/customer-billing-customer-edit-usage-information/customer-billing-customer-edit-usage-information.component';
import { SelectSearchModule } from '@fi-shared/fi-select-search/select-search.module';
import { FiToggleSwitchModule } from '@fi-shared/fi-toggle-switch/fi-toggle-switch.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ComponentsModule,
        UtilitiesModule,
        BillingComponentsModule,
        CustomerBillingComponentsModule,
        MatRadioModule,
        MatCheckboxModule,
        FiPageHeaderModule,
        MatButtonModule,
        MatCardModule,
        MatFormFieldModule,
        MatInputModule,
        SelectSearchModule,
        FiToggleSwitchModule,
    ],
    declarations: [
        CustomerBillingCustomerListComponent,
        CustomerBillingCustomerViewComponent,
        OtherInvoicesListItemComponent,
        MonthlyInvoicesListItemComponent,
        CustomerBillingCustomerEditComponent,
        CustomerBillingCustomerListStateComponent,
        CustomerBillingCustomerEditCustomerInformationComponent,
        CustomerBillingCustomerEditPaymentInformationComponent,
        CustomerBillingCustomerEditInvoiceInformationComponent,
        CustomerBillingCustomerEditCreditCardInformationComponent,
        CustomerBillingCustomerEditUsageInformationComponent,
    ],
    providers: [CustomerService],
})
export class CustomerBillingCustomerModule {}
